import { useEffect, useState } from "react";
import { IconButton, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import { HelpOutlineRounded } from "@mui/icons-material";
import classNames from "classnames";

const PreferenceItem = ({
  stateVar,
  prefType,
  setter,
  options,
  toolTipContent,
}: {
  stateVar?: string;
  prefType: string;
  setter?: (string) => void;
  options?: string[];
  toolTipContent?: string | null;
}) => {
  const [selectedOption, setSelectedOption] = useState(stateVar);

  useEffect(() => {
    setSelectedOption(stateVar);
  }, [stateVar]);

  const handleAlignment = (newAlignment: string | null) => {
    if (newAlignment !== null) {
      setSelectedOption(newAlignment);
      setter?.(newAlignment);
    }
  };

  return (
    <div className="flex flex-col gap-y-2 sm:gap-y-4 sm:flex-row justify-between">
      <div>
        <Typography
          variant="body2/regular-400"
          className="text-mui-black-60 dark:text-mui-white-70 pe-1"
        >
          {prefType}
        </Typography>
        {toolTipContent && (
          <Tooltip
            placement="right"
            title={<p className="text-center text-xs">{toolTipContent}</p>}
            classes={{
              tooltip: "!w-[210px]",
            }}
          >
            <IconButton>
              <HelpOutlineRounded className="text-mui-black-60 dark:text-mui-white-70 opacity-60 !w-4 !h-4" />
            </IconButton>
          </Tooltip>
        )}
      </div>

      <div className="w-[292px] md:w-[340px] lg:w-[462px] self-center">
        <div className="relative w-full">
          <div
            className="absolute inset-y-0 transition-transform duration-300 ease-in-out rounded-full bg-tgpt-secondary-states-focus z-0 m-1"

            style={{
              width: `calc(${100 / options.length}% - 8px)`,
              transform: `translateX(calc(${options.indexOf(selectedOption) * 100}% + ${options.indexOf(selectedOption) * 8}px))`,
            }}
          />
          <ToggleButtonGroup
            exclusive
            aria-label="text alignment"
            className="h-[42px] bg-tgpt-secondary-accentLight !rounded-full"
            fullWidth
          >
            {options.map(option => (
              <ToggleButton
                key={option}
                value={option}
                size="medium"
                className={classNames(
                  "category-button !border-0 hover:!rounded-full !text-[13px]",
                  { "!rounded-full !bg-transparent": selectedOption === option },
                )}
                selected={selectedOption === option}
                onClick={() => {
                  handleAlignment(option);
                }}
                aria-label="left aligned"
              >
                {option.charAt(0).toUpperCase() + option.slice(1)}
              </ToggleButton>
            ))}
          </ToggleButtonGroup>
        </div>
      </div>
    </div>
  );
};

export default PreferenceItem;
